// 总线单例与全局接线：服务端消息 → 实时 store；权限变化 → 失效查询缓存。

import { api } from "./api";
import { applyServerMessage, staleLive } from "@/store/robots";
import { consoleUrl, RealtimeBus } from "./ws";

export const bus = new RealtimeBus({
  getTicket: async () => (await api<{ ticket: string }>("/v1/realtime/ticket", { method: "POST" })).ticket,
  openSocket: (url) => new WebSocket(url),
  url: consoleUrl,
});

bus.on(applyServerMessage);
bus.onStatus((s) => {
  if (s === "closed") staleLive();
});
